import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig';
import { AuthProvider } from './context/AuthContext';
import { useTheme } from './hooks/useTheme';
import Dashboard from './components/Dashboard';
import Configuration from './components/Configuration';
import AreaOrganigrama from './components/AreaOrganigrama';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Inicializar MSAL y manejar redirecciones
msalInstance.initialize().then(() => {
  // Manejar redirección después del login
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      console.log('✅ MSAL - Redirección completada:', response);
    }
  }).catch((error) => {
    console.error('❌ MSAL - Error en redirección:', error);
  });
});

function App() {
  const [msalInitialized, setMsalInitialized] = useState(false);

  // Inicializar tema (dark mode)
  useTheme();

  // Esperar a que MSAL se inicialice completamente
  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        console.log('✅ MSAL inicializado correctamente');
        
        // Verificar si hay cuentas existentes
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          console.log('✅ MSAL - Sesión existente encontrada:', accounts[0].username);
          msalInstance.setActiveAccount(accounts[0]);
        }
        
        // Event listener para cambios de cuenta
        msalInstance.addEventCallback((event) => {
          if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            console.log('✅ MSAL - Login exitoso:', event.payload);
          }
          if (event.eventType === EventType.LOGOUT_SUCCESS) {
            console.log('✅ MSAL - Logout exitoso');
          }
        });
        
        setMsalInitialized(true);
      } catch (error) {
        console.error('❌ Error inicializando MSAL:', error);
        setMsalInitialized(true); // Continuar aunque haya error
      }
    };

    initializeMsal();
  }, []);


  // Mostrar loading mientras MSAL se inicializa
  if (!msalInitialized) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner message="Inicializando aplicación..." />
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <Router>
          <div className="App">
            <ProtectedRoute>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/configuration" element={<Configuration />} />
                <Route path="/area/:id" element={<AreaOrganigrama />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </ProtectedRoute>
          </div>
        </Router>
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;